import { c as _c } from "react/compiler-runtime";
import { ChainBadge, NATIVE_CURRENCY_ADDRESS } from "@opensea/app-kit";
import { Badge, classNames, FlexCenter, FlexColumn, FlexEnd, ItemAvatar, ItemContent, ItemDescription, ItemSide, ItemTitle, NumberDisplay, RadioGroup, RadioGroupItem, Separator, Skeleton, SkeletonCircle, SpaceBetween, TextBody, TextLabel, Tooltip } from "@opensea/ui-kit";
import { ArrowRightAlt, ErrorFilled, Info } from "@opensea/ui-kit/icons";
import { range } from "es-toolkit/math";
import { readFragment } from "gql.tada";
import { useEffect, useState } from "react";
import { useTranslations } from "use-intl";
import { useSnapshot } from "valtio";
import { Button } from "../../../../../components/Button";
import { DestinationWalletSelect } from "../../../../../components/DestinationWalletSelect/DestinationWalletSelect";
import { Item } from "../../../../../components/Item";
import { SmartContractWalletWarningModal } from "../../../../../components/SmartContractWalletWarningModal";
import { useAddressCompatibility } from "../../../../../hooks/useAddressCompatibility";
import { useAddress } from "../../../../../polychain/hooks";
import { useAccount } from "../../../../../polychain/hooks/useAccount";
import { FlowState } from "../../../../../stores/flowStore";
import { useSufficientBalances } from "../../../../../utils/balanceUtils";
import { useIsSmartContractWallet } from "../../../../hooks/useIsSmartContractWallet";
import { itemVariants } from "../../../../PaymentSection/constants";
import { CurrencySelector_relayerFulfillmentFragment } from "./CurrencySelector.fragment";
const NON_EXPANDED_BALANCES_LIMIT = 1;
export function CurrencySelector(t0) {
  const $ = _c(84);
  const {
    className,
    onSelect,
    totalUsdPrice,
    nftChain,
    relayerFulfillment: relayerFulfillmentKey,
    defaultCurrency,
    onWalletSelect,
    walletDestination,
    onBalancesReady
  } = t0;
  const t = useTranslations("wallet.CurrencySelector");
  const {
    connectorId
  } = useAccount();
  const currentAddress = useAddress();
  const {
    flow
  } = useSnapshot(FlowState);
  const isClaim = flow?.isClaim ?? false;
  const relayerFulfillment = readFragment(CurrencySelector_relayerFulfillmentFragment, relayerFulfillmentKey);
  const onlyCurrency = relayerFulfillment ? undefined : defaultCurrency;
  let t1;
  if ($[0] !== defaultCurrency || $[1] !== nftChain || $[2] !== onlyCurrency || $[3] !== totalUsdPrice) {
    t1 = {
      totalUsdPrice,
      onlyCurrency,
      preferredCurrency: defaultCurrency,
      targetChain: nftChain
    };
    $[0] = defaultCurrency;
    $[1] = nftChain;
    $[2] = onlyCurrency;
    $[3] = totalUsdPrice;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    balances: allValidBalances,
    loading
  } = useSufficientBalances(t1);
  let t2;
  if ($[5] !== allValidBalances || $[6] !== isClaim) {
    t2 = isClaim ? allValidBalances.filter(_temp) : allValidBalances;
    $[5] = allValidBalances;
    $[6] = isClaim;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const validBalances = t2;
  const [selectedBalance, setSelectedBalance] = useState(undefined);
  let t3;
  if ($[8] !== onSelect || $[9] !== selectedBalance || $[10] !== validBalances[0] || $[11] !== validBalances.length) {
    t3 = () => {
      if (validBalances.length > 0 && !selectedBalance) {
        const balanceToSelect = validBalances[0];
        setSelectedBalance(balanceToSelect);
        onSelect({
          contractAddress: balanceToSelect.currency.contractAddress,
          chainIdentifier: balanceToSelect.currency.chainIdentifier
        });
      }
    };
    $[8] = onSelect;
    $[9] = selectedBalance;
    $[10] = validBalances[0];
    $[11] = validBalances.length;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== onSelect || $[14] !== selectedBalance || $[15] !== validBalances) {
    t4 = [validBalances, selectedBalance, onSelect];
    $[13] = onSelect;
    $[14] = selectedBalance;
    $[15] = validBalances;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  useEffect(t3, t4);
  const [expanded, setExpanded] = useState(false);
  const isPhantomAbstractWarning = connectorId === "app.phantom" && nftChain === "abstract";
  const handleSelect = balance_0 => {
    if (isSmartContractWallet) {
      setSmartContractWalletWarningOpen(true);
      return;
    }
    if (balance_0) {
      onSelect({
        contractAddress: balance_0.currency.contractAddress,
        chainIdentifier: balance_0.currency.chainIdentifier
      });
    }
  };
  const onValueChange = balanceId => {
    const balance_1 = validBalances.find(b => b.id === balanceId);
    setSelectedBalance(balance_1);
    if (!expanded) {
      handleSelect(balance_1);
    }
  };
  const isSmartContractWallet = useIsSmartContractWallet();
  const [smartContractWalletWarningOpen, t5] = useState(false);
  const setSmartContractWalletWarningOpen = t5;
  const hasMoreOptions = validBalances.length > NON_EXPANDED_BALANCES_LIMIT;
  const isAddressCompatible = useAddressCompatibility(currentAddress, nftChain);
  let t6;
  if ($[17] !== loading || $[18] !== onBalancesReady) {
    t6 = () => {
      if (!loading) {
        onBalancesReady();
      }
    };
    $[17] = loading;
    $[18] = onBalancesReady;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== loading) {
    t7 = [loading];
    $[20] = loading;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  useEffect(t6, t7);
  if (loading) {
    let t8;
    if ($[22] !== className) {
      t8 = <CurrencySelectorSkeleton className={className} />;
      $[22] = className;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    return t8;
  }
  if (validBalances.length === 0) {
    return null;
  }
  let t8;
  if ($[24] !== expanded || $[25] !== hasMoreOptions || $[26] !== t) {
    t8 = expanded ? <Tooltip content={<div className="max-w-[400px]">{t("tooltip")}</div>}><FlexCenter className="gap-2 text-text-secondary"><TextLabel size="xs">{t("paymentMethod")}</TextLabel><ArrowRightAlt size={16} /><TextLabel color="text-secondary" size="xs">{t("selectToken")}</TextLabel><Info size={14} /></FlexCenter></Tooltip> : <SpaceBetween className="w-full items-center"><Tooltip content={<div className="max-w-[400px]">{t("tooltip")}</div>}><TextLabel className="flex items-center gap-1" color="text-secondary" size="xs" weight="semibold">{t("token")}<Info size={14} /></TextLabel></Tooltip>{!expanded && hasMoreOptions && <Button onClick={() => setExpanded(true)} size="sm" variant="secondary">{t("change")}</Button>}</SpaceBetween>;
    $[24] = expanded;
    $[25] = hasMoreOptions;
    $[26] = t;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  const title = t8;
  let t9;
  if ($[28] !== onValueChange || $[29] !== selectedBalance || $[30] !== t || $[31] !== validBalances) {
    t9 = count => {
      const getBalancesToShow = () => {
        if (!count) {
          return validBalances;
        }
        if (!selectedBalance) {
          return validBalances.slice(0, count);
        }
        return [selectedBalance, ...validBalances.filter(b_0 => b_0.id !== selectedBalance.id).slice(0, count - 1)];
      };
      const balancesToShow = getBalancesToShow();
      return <RadioGroup className="overflow-y-auto" onValueChange={onValueChange} value={selectedBalance?.id}>{balancesToShow.map(balance_2 => <Item className={itemVariants()} key={balance_2.id} onClick={() => onValueChange(balance_2.id)}><ItemAvatar badge={<ChainBadge identifier={balance_2.currency.chainIdentifier} size="xs" />} src={balance_2.currency.imageUrl} /><ItemContent><ItemTitle size="sm">{balance_2.currency.name}</ItemTitle><ItemDescription className="font-mono" size="xs">{t("balance")} <NumberDisplay suffix={balance_2.currency.symbol} value={balance_2.quantity ?? 0} /></ItemDescription></ItemContent><ItemSide><RadioGroupItem value={balance_2.id} /></ItemSide></Item>)}</RadioGroup>;
    };
    $[28] = onValueChange;
    $[29] = selectedBalance;
    $[30] = t;
    $[31] = validBalances;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  const renderItems = t9;
  const t10 = !expanded && "hidden";
  let t11;
  if ($[33] !== t10) {
    t11 = classNames("absolute inset-0 z-1 gap-4 bg-bg-app", t10);
    $[33] = t10;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== renderItems) {
    t12 = renderItems();
    $[35] = renderItems;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Separator className="my-2" />;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== handleSelect || $[39] !== selectedBalance) {
    t14 = () => {
      setExpanded(false);
      handleSelect(selectedBalance);
    };
    $[38] = handleSelect;
    $[39] = selectedBalance;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== t) {
    t15 = t("save");
    $[41] = t;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== t14 || $[44] !== t15) {
    t16 = <FlexEnd className="w-full"><Button onClick={t14} size="sm">{t15}</Button></FlexEnd>;
    $[43] = t14;
    $[44] = t15;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== t11 || $[47] !== t12 || $[48] !== t16 || $[49] !== title) {
    t17 = <FlexColumn className={t11}>{title}{t12}{t13}{t16}</FlexColumn>;
    $[46] = t11;
    $[47] = t12;
    $[48] = t16;
    $[49] = title;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  const t18 = expanded && "invisible min-h-[392px]";
  let t19;
  if ($[51] !== className || $[52] !== t18) {
    t19 = classNames("gap-4", t18, className);
    $[51] = className;
    $[52] = t18;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  let t20;
  if ($[54] !== renderItems) {
    t20 = renderItems(NON_EXPANDED_BALANCES_LIMIT);
    $[54] = renderItems;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== isAddressCompatible || $[57] !== nftChain || $[58] !== onWalletSelect || $[59] !== t || $[60] !== walletDestination) {
    t21 = onWalletSelect && !isAddressCompatible && <DestinationWalletSelect className="mt-4" destinationChain={nftChain} label={<div className="mb-2"><TextLabel color="text-secondary" weight="semibold">{t("destinationWallet")}</TextLabel></div>} onWalletSelect={onWalletSelect} walletDestination={walletDestination} />;
    $[56] = isAddressCompatible;
    $[57] = nftChain;
    $[58] = onWalletSelect;
    $[59] = t;
    $[60] = walletDestination;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  let t22;
  if ($[62] !== isPhantomAbstractWarning || $[63] !== t) {
    t22 = isPhantomAbstractWarning && <FlexColumn className="rounded-xl border border-border-2 p-3"><Badge className="mb-2 self-start" icon={ErrorFilled} variant="warning">{t("warning")}</Badge><TextBody color="text-secondary" size="sm">{t("phantomAbstractWarning")}</TextBody></FlexColumn>;
    $[62] = isPhantomAbstractWarning;
    $[63] = t;
    $[64] = t22;
  } else {
    t22 = $[64];
  }
  let t23;
  if ($[65] !== t19 || $[66] !== t20 || $[67] !== t21 || $[68] !== t22 || $[69] !== title) {
    t23 = <FlexColumn className={t19}>{title}{t20}{t21}{t22}</FlexColumn>;
    $[65] = t19;
    $[66] = t20;
    $[67] = t21;
    $[68] = t22;
    $[69] = title;
    $[70] = t23;
  } else {
    t23 = $[70];
  }
  let t24;
  if ($[71] !== setSmartContractWalletWarningOpen) {
    t24 = () => setSmartContractWalletWarningOpen(false);
    $[71] = setSmartContractWalletWarningOpen;
    $[72] = t24;
  } else {
    t24 = $[72];
  }
  let t25;
  if ($[73] !== onSelect || $[74] !== selectedBalance) {
    t25 = () => {
      if (!selectedBalance) {
        return;
      }
      onSelect({
        contractAddress: selectedBalance.currency.contractAddress,
        chainIdentifier: selectedBalance.currency.chainIdentifier
      });
    };
    $[73] = onSelect;
    $[74] = selectedBalance;
    $[75] = t25;
  } else {
    t25 = $[75];
  }
  let t26;
  if ($[76] !== smartContractWalletWarningOpen || $[77] !== t24 || $[78] !== t25) {
    t26 = <SmartContractWalletWarningModal onCancel={t24} onContinue={t25} open={smartContractWalletWarningOpen} />;
    $[76] = smartContractWalletWarningOpen;
    $[77] = t24;
    $[78] = t25;
    $[79] = t26;
  } else {
    t26 = $[79];
  }
  let t27;
  if ($[80] !== t17 || $[81] !== t23 || $[82] !== t26) {
    t27 = <>{t17}{t23}{t26}</>;
    $[80] = t17;
    $[81] = t23;
    $[82] = t26;
    $[83] = t27;
  } else {
    t27 = $[83];
  }
  return t27;
}
function _temp(balance) {
  return balance.currency.contractAddress === NATIVE_CURRENCY_ADDRESS;
}
function CurrencySelectorSkeleton(t0) {
  const $ = _c(11);
  const {
    className
  } = t0;
  const t = useTranslations("wallet.CurrencySelector");
  let t1;
  if ($[0] !== className) {
    t1 = classNames("mt-4 gap-4", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("token");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Info size={14} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <SpaceBetween className="w-full items-center"><TextLabel className="flex items-center gap-1" color="text-secondary" size="xs" weight="semibold">{t2}{t3}</TextLabel></SpaceBetween>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = range(2).map(_temp2);
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t4) {
    t6 = <FlexColumn className={t1}>{t4}{t5}</FlexColumn>;
    $[8] = t1;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp2(i) {
  return <Item className={itemVariants()} key={i}><ItemAvatar><SkeletonCircle className="size-10" /></ItemAvatar><ItemContent className="gap-1"><Skeleton className="w-30" /><Skeleton className="w-20" /></ItemContent><ItemSide><SkeletonCircle className="size-4" /></ItemSide></Item>;
}